import { TST_BLESSED_ID_COLUMN_SELECTION } from "@impero-com/ui";
import {
    booleanCodec,
    dateRangeCodec,
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export function buildTestingActivityListTableStateStorageKey(
    testingProgramId: number
) {
    return `testingActivityListForProgram-${testingProgramId}`;
}
export const TESTING_ACTIVITY_LIST_COLUMN_IDS = {
    TITLE: "title",
    ENTITIES_TO_TEST: "entitiesToTest",
    TAGS: "tags",
    DUE_DATE: "dueDate",
    USER_RESPONSIBLE: "userResponsible",
    EFFECTIVENESS: "effectiveness",
    STATUS: "status",
    SAMPLING_PERIOD_START: "samplingPeriodStart",
    SAMPLING_PERIOD_END: "samplingPeriodEnd",
    RESPONSIBLE_DUE_DATE: "responsibleDueDate",
    FIRST_REVIEWER: "firstReviewer",
    FIRST_REVIEWER_DUE_DATE: "firstReviewerDueDate",
    SECOND_REVIEWER: "secondReviewer",
    SECOND_REVIEWER_DUE_DATE: "secondReviewerDueDate",
    SUBMITTED_DATE: "submittedDate",
    REVIEWED_DATE: "reviewedDate",
    SECOND_REVIEWED_DATE: "secondReviewedDate",
    DESCRIPTION: "description",
} as const;

export const testingActivityListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        columnVisibility: {
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.SAMPLING_PERIOD_START]: false,
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.SAMPLING_PERIOD_END]: false,
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.RESPONSIBLE_DUE_DATE]: false,
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.FIRST_REVIEWER]: false,
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.FIRST_REVIEWER_DUE_DATE]: false,
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.SECOND_REVIEWER]: false,
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.SECOND_REVIEWER_DUE_DATE]: false,
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.SUBMITTED_DATE]: false,
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.REVIEWED_DATE]: false,
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.SECOND_REVIEWED_DATE]: false,
            [TESTING_ACTIVITY_LIST_COLUMN_IDS.DESCRIPTION]: false,
        },
        sorting: [{ id: TESTING_ACTIVITY_LIST_COLUMN_IDS.TITLE, desc: false }],
        columnPinning: {
            left: [TST_BLESSED_ID_COLUMN_SELECTION],
        },
        columnOrder: [
            TST_BLESSED_ID_COLUMN_SELECTION,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.TITLE,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.ENTITIES_TO_TEST,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.TAGS,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.DUE_DATE,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.USER_RESPONSIBLE,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.EFFECTIVENESS,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.STATUS,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.SAMPLING_PERIOD_START,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.SAMPLING_PERIOD_END,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.RESPONSIBLE_DUE_DATE,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.FIRST_REVIEWER,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.FIRST_REVIEWER_DUE_DATE,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.SECOND_REVIEWER,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.SECOND_REVIEWER_DUE_DATE,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.SUBMITTED_DATE,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.REVIEWED_DATE,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.SECOND_REVIEWED_DATE,
            TESTING_ACTIVITY_LIST_COLUMN_IDS.DESCRIPTION,
        ],
        dataParams: {
            active: true,
            archived: false,
        },
    };

export const testingActivityListDataParamsCodecMap = {
    active: booleanCodec,
    archived: booleanCodec,
};

export const testingActivityListColumnFiltersCodecMap = {
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.ENTITIES_TO_TEST]:
        withModeCodec(encodedArrayCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.TAGS]: withModeCodec(encodedArrayCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.DUE_DATE]: withModeCodec(dateRangeCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.USER_RESPONSIBLE]:
        withModeCodec(encodedArrayCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.EFFECTIVENESS]:
        withModeCodec(encodedArrayCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.STATUS]: withModeCodec(encodedArrayCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.SAMPLING_PERIOD_START]:
        withModeCodec(dateRangeCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.SAMPLING_PERIOD_END]:
        withModeCodec(dateRangeCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.RESPONSIBLE_DUE_DATE]:
        withModeCodec(dateRangeCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.FIRST_REVIEWER]:
        withModeCodec(encodedArrayCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.SECOND_REVIEWED_DATE]:
        withModeCodec(dateRangeCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.SECOND_REVIEWER_DUE_DATE]:
        withModeCodec(dateRangeCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.REVIEWED_DATE]:
        withModeCodec(dateRangeCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.FIRST_REVIEWER_DUE_DATE]:
        withModeCodec(dateRangeCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.SECOND_REVIEWER]:
        withModeCodec(encodedArrayCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.SUBMITTED_DATE]:
        withModeCodec(dateRangeCodec),
};
